import { useAppTranslation } from 'app/config/i18Config/hooks';
import { BoxHistoryActionNames, HistoryActionName, WarehouseHistoryActionNames } from 'entities/History';
import { FC, memo, useCallback, useMemo } from 'react';
import { MultipleSelect } from 'shared/ui/MultipleSelect';
import { HistoryFilterKeys } from '../../model/types';

interface ActionTypeSelectProps {
  value: string[];
  onChange: (value: string[]) => void;
  onClear: (filterKey: string) => void;
}

export const ActionTypeSelect: FC<ActionTypeSelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation(['contracts', 'common']);

  const actionType = useMemo<Array<{ label: string; value: HistoryActionName }>>(() => {
    return [
      { label: t('Attempt to open box'), value: BoxHistoryActionNames.box_open_attempt },
      { label: t('Box opened'), value: BoxHistoryActionNames.box_open },
      { label: t('Box closed'), value: BoxHistoryActionNames.box_close },
      { label: t('Box open for a long time'), value: BoxHistoryActionNames.box_open_long_time },
      { label: t('Box unauthorized access'), value: BoxHistoryActionNames.box_unauthorized_access },
      { label: t('Box updated'), value: BoxHistoryActionNames.box_update },
      { label: t('Box created'), value: BoxHistoryActionNames.box_create },
      { label: t('Attempt to open door'), value: WarehouseHistoryActionNames.door_open_attempt },
      { label: t('Siren turned on'), value: WarehouseHistoryActionNames.siren_turned_on },
    ];
  }, [t]);

  const clearFilter = useCallback(() => {
    onClear(HistoryFilterKeys.actionTypes);
  }, [onClear]);

  const handleChange = useCallback(
    (value: string[]): void => {
      value.length ? onChange(value) : clearFilter();
    },
    [onChange, clearFilter],
  );

  return (
    <MultipleSelect
      containerClassName="flex-1"
      className="w-full"
      label={t('Action type')}
      placeholder={t('All')}
      bordered
      allowClear
      options={actionType}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
